import { render, staticRenderFns } from "./CompanyCategoryModalForm.vue?vue&type=template&id=9c8979a2"
import script from "./CompanyCategoryModalForm.vue?vue&type=script&lang=js"
export * from "./CompanyCategoryModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports